import {
  Building2,
  Database,
  LayoutDashboard,
  LineChart,
  Settings2,
  ShieldUser,
  Users
} from '@tamagui/lucide-icons';
import { Route } from '@unistocks/features/navigation/route';
import { usePermission } from '@unistocks/shared/hooks/use-permission';
import { t } from '@unistocks/shared/localization/index.ts';
import { UnistocksPermissions } from '@unistocks/shared/permissions';

export const useAdminRoutes = (): Route[] => {
  const hasAdminDashboard = usePermission(UnistocksPermissions.HostDashboard);
  const hasUserManagement = usePermission(UnistocksPermissions.UserManagement);
  const hasRoleManagement = usePermission(UnistocksPermissions.Roles);
  const hasTenantManagement = usePermission(UnistocksPermissions.TenantManagement);
  const hasAssetManagement = usePermission(UnistocksPermissions.AssetManagementList);
  const hasDataSourceManagement = usePermission(UnistocksPermissions.DataSourceManagement);
  const hasSettingManagementEmailing = usePermission(
    UnistocksPermissions.SettingManagementEmailing
  );
  const hasSettingManagementIdentity = usePermission(
    UnistocksPermissions.SettingManagementIdentity
  );
  const hasSettingManagementFeatures = usePermission(
    UnistocksPermissions.SettingManagementFeatures
  );

  const hasSettingManagement =
    hasSettingManagementEmailing || hasSettingManagementIdentity || hasSettingManagementFeatures;

  const routes: Route[] = [];

  if (hasAdminDashboard) {
    routes.push({
      key: 'admin-dashboard',
      rootPathName: 'index',
      name: t('::Menu:Dashboard'),
      href: '/(admin)',
      Icon: props => <LayoutDashboard {...props} />
    });
  }

  if (hasUserManagement) {
    routes.push({
      key: 'admin-users',
      rootPathName: 'user-management',
      name: t('AbpIdentity::Users'),
      href: '/(admin)/user-management',
      Icon: props => <Users {...props} />
    });
  }

  if (hasRoleManagement) {
    routes.push({
      key: 'admin-role-management',
      rootPathName: 'role-management',
      name: t('AbpIdentity::Roles'),
      href: '/(admin)/role-management',
      Icon: props => <ShieldUser {...props} />
    });
  }

  if (hasTenantManagement) {
    routes.push({
      key: 'admin-tenant-management',
      rootPathName: 'tenant-management',
      name: t('AbpTenantManagement::Menu:TenantManagement'),
      href: '/(admin)/tenant-management',
      Icon: props => <Building2 {...props} />
    });
  }

  if (hasAssetManagement) {
    routes.push({
      key: 'admin-assets',
      rootPathName: 'asset-management',
      name: t('::Assets'),
      href: '/(admin)/asset-management',
      Icon: props => <LineChart {...props} />
    });
  }

  if (hasDataSourceManagement) {
    routes.push({
      key: 'admin-data-sources',
      rootPathName: 'data-sources',
      name: t('::Menu:DataSources'),
      href: '/(admin)/data-sources',
      Icon: props => <Database {...props} />
    });
  }

  if (hasSettingManagement) {
    routes.push({
      key: 'admin-setting-management',
      rootPathName: 'setting-management',
      name: t('AbpSettingManagement::Settings'),
      href: '/(admin)/setting-management',
      Icon: props => <Settings2 {...props} />
    });
  }

  return routes;
};
